import Content from "./Content";
import ContentTypes from "./ContentTypes";

/**
* ObjectContent.js
* 
* Created on 3-mei-2016, 14:37:03
*
* @author Pascal van Beek for Ranj
**/
export default class ObjectContent extends Content {
    constructor(languagePack, contentID, object, label) {
        super(ObjectContent.NAME, ContentTypes.TYPE_OBJECT, label, languagePack, contentID);
        this.object = object;
    }

    getObject() {
        return this.getLanguagePackContent(ObjectContent.OBJECT_LABEL, ObjectContent.TYPE);
    }

    setObject(value) {
        this.setLanguagePackContent(ObjectContent.OBJECT_LABEL, ObjectContent.TYPE, value);
    }

    remove() {
        this.removeLanguagePackContent(ObjectContent.OBJECT_LABEL, ObjectContent.TYPE);
        super.remove();
    }

    convertToObject() {
        return this.getObject([]);
    }

    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_OBJECT, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setObject(this.getObject());
        return clone;
    }
}


ObjectContent.NAME = "JSON Object";
ObjectContent.TYPE = "engObjectContent";
ObjectContent.OBJECT_LABEL = "object";


